module.exports = __webpack_public_path__ + "imgs/gosPartnersLogo1.99887578.webp";